<template>
    <div class="passengers">
        <!-- <div class="row">
            <div class="col-6 m-sm-auto"><h4>Conductor / Pasajeros</h4></div>
        </div> -->
        <div class="row">
            <div class="col-12 col-sm">
                <app-form-text-input
                    label="Documento"
                    :has-error="$v.passenger.document.$error"
                    @input="$v.passenger.document.$touch()"
                    error-message="Debe diligenciar el documento del pasajero"
                    v-model="passenger.document"
                    @change="validateVisitor"
                />
            </div>
            <div class="col-12 col-sm">
                <app-form-text-input
                    label="Nombre"
                    :disabled="searching"
                    :has-error="$v.passenger.name.$error"
                    @input="$v.passenger.name.$touch()"
                    error-message="Debe diligenciar el nombre del pasajero"
                    v-model="passenger.name"
                />
            </div>
            <div class="col-12 col-sm">
                <app-form-select-input
                    label="Tipo"
                    :disabled="searching"
                    :has-error="$v.passenger.passengerTypeId.$error"
                    @change="$v.passenger.passengerTypeId.$touch()"
                    :options="passengerTypes"
                    error-message="Debe diligenciar el tipo de pasajero"
                    v-model="passenger.passengerTypeId"
                />
            </div>
            <div class="col-12 col-sm">
                <app-form-select-input
                    label="ARL"
                    :disabled="searching"
                    :options="arls"
                    v-model="passenger.arlId"
                />
            </div>
            <div class="col-12 col-sm">
                <app-form-text-input
                    type="number"
                    step="0.01"
                    label="Temperatura"
                    :disabled="searching"
                    error-message="Debe ingresar la temperatura"
                    v-model="passenger.temperature"
                />
            </div>
            <div class="col-12 col-sm">
                <app-form-text-input
                    label="Teléfono"
                    :disabled="searching"
                    v-model="passenger.phone"
                />
            </div>
            <div class="col-12 col-sm-1">
                <div class="form-group">
                    <label for="">&nbsp;</label>
                    <button
                        class="btn btn-primary btn-block"
                        @click="addPassenger"
                    >
                        <i class="fa fa-plus"></i>
                    </button>
                </div>
            </div>
        </div>
        <div class="row" v-if="passengers.length > 0">
            <div class="col">
                <table class="table table-sm table-bordered">
                    <thead class="thead-orange">
                        <tr class="thead-orange">
                            <th>Documento</th>
                            <th>Nombre</th>
                            <th>Tipo</th>
                            <th>ARL</th>
                            <th>Temperatura</th>
                            <th>Telefono</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(person, index) in passengers" :key="index">
                            <td>
                                <b-badge
                                    variant="danger"
                                    title="Usuario Restringido"
                                    v-if="isRestricted(person.document)"
                                >
                                    <i
                                        class="fa fa-exclamation-triangle"
                                        aria-hidden="true"
                                    ></i>
                                </b-badge>
                                {{ person.document }}
                            </td>
                            <td>{{ person.name }}</td>
                            <td>{{ person.passengerType.name }}</td>
                            <td>{{ !!person.arl ? person.arl.name : '' }}</td>
                            <td>{{ person.temperature }}</td>
                            <td>{{ person.phone }}</td>
                            <td>
                                <button
                                    class="btn btn-danger"
                                    @click="removePassenger(index)"
                                >
                                    <i class="fa fa-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <app-pop-up
            id="restricted-visitor-window"
            size="large"
            title="Pasajero Restringido"
            :on-close="confirmRestrictedVisitor"
        >
            <template slot="body">
                <app-restricted-visitor-card :visitor="restrictedVisitor" />
            </template>
            <template slot="buttons">
                <b-btn variant="danger" @click="acceptRestrictedVisitor"
                    ><i class="fa fa-alert"></i> Ingresar de todos modos</b-btn
                >
            </template>
        </app-pop-up>
    </div>
</template>
<script>
import FormTextInput from '../../../../../UI/Controls/Forms/FormTextInput.vue'
import FormSelectInput from '../../../../../UI/Controls/Forms/FormSelectInput.vue'
import { required, numeric } from 'vuelidate/lib/validators'
import clientsRepository from '../../../../../../repositories/clients.repository'
import vigilanceRepository from '../../../../../../repositories/vigilance.repository'
import { alphaSpaces } from '../../../../../../utils/CustomValidators'
import RestrictedVisitorCard from '../../RestrictedVisitorCard/RestrictedVisitorCard'
import { mapGetters } from 'vuex'
export default {
    components: {
        appFormTextInput: FormTextInput,
        appFormSelectInput: FormSelectInput,
        appRestrictedVisitorCard: RestrictedVisitorCard,
    },
    props: {
        value: '',
    },
    data() {
        return {
            passenger: {
                document: '',
                name: '',
                passengerTypeId: '',
                phone: '',
                arlId: '',
                temperature: '',
            },
            passengers: [],
            // passengerTypes: [],
            searching: false,
            restrictedVisitor: '',
            acceptedRestrictedVisitor: false,
        }
    },
    watch: {
        value(val) {
            const passengers = val.map((item) => {
                let passengerType = this.passengerTypes.find(
                    (type) => type.id === item.passengerTypeId
                )
                // Si no encuentra el tipo de visitante es porque es interno y se pone por defecto conductor
                if (!passengerType) {
                    passengerType = this.passengerTypes.find(
                        (item) => item.slug === 'conductor'
                    )
                }

                return Object.assign({ passengerType }, item)
            })
            this.passengers = passengers
        },
    },
    validations: {
        passenger: {
            document: { required, numeric },
            name: { required, alphaSpaces },
            passengerTypeId: { required },
        },
    },
    computed: {
        ...mapGetters(['passengerTypes', 'restrictedVisitors', 'arls']),
        pilotsCount() {
            const pilots = this.passengers.filter(
                (pilot) =>
                    !!pilot.internal ||
                    this.passengerTypes.find(
                        (pt) => pt.id === pilot.passengerTypeId
                    )
            )
            // const pilots = this.passengers.filter(item => this.passengerTypes.find(pt => parseInt(pt.id) === parseInt(item.passengerTypeId)).slug === 'conductor');
            return !!pilots ? pilots.length : 0
        },
    },
    methods: {
        isRestricted(document) {
            return !!this.restrictedVisitors.find(
                (visitor) => visitor.document === document
            )
        },
        validateVisitor() {
            const restrictedVisitor = this.restrictedVisitors.find(
                (visitor) => visitor.document === this.passenger.document
            )

            if (!restrictedVisitor) return this.searchPerson()

            this.restrictedVisitor = restrictedVisitor
            this.$bus.$emit('restricted-visitor-window.open')
        },
        confirmRestrictedVisitor() {
            if (this.acceptedRestrictedVisitor) return

            this.passenger.document = ''
            this.restrictedVisitor = ''
            this.$v.passenger.document.$reset()
        },
        acceptRestrictedVisitor() {
            this.acceptedRestrictedVisitor = true
            this.$bus.$emit('restricted-visitor-window.close')
            this.acceptedRestrictedVisitor = false
            this.searchPerson()
        },
        searchPerson() {
            this.searching = true
            const cr = Object.assign({}, clientsRepository)

            cr.searchPerson(this.client.id, this.passenger.document)
                .then((data) => {
                    this.searching = false
                    if (!!data.length) {
                        this.passenger.name = data[0].name
                        this.passenger.phone = data[0].phone
                        !!data[0].arl_id &&
                            (this.passenger.arlId = data[0].arl_id)
                    }
                })
                .catch((error) => {
                    this.searching = false
                    toastr.error(
                        'Ocurrió un error al buscar el documento del pasajero'
                    )
                })
        },
        addPassenger() {
            this.$v.$touch()
            if (this.$v.$invalid) {
                toastr.error('Debe diligenciar correctamente todos los campos')
                return false
            }
            const passengerType = this.passengerTypes.find(
                (item) => item.id === parseInt(this.passenger.passengerTypeId)
            )
            if (passengerType.slug === 'conductor' && this.pilotsCount > 0) {
                toastr.error('Solo puede agregar un conductor')
                return false
            }

            if (
                this.passengers.filter(
                    (item) => item.document === this.passenger.document
                ).length > 0
            ) {
                toastr.error('Ya agregó un pasajero con ese documento')
                return false
            }

            const arl = !!this.passenger.arlId
                ? this.arls.find((item) => item.id === this.passenger.arlId)
                : {}

            // const passenger = Object.assign({ passengerType }, this.passenger);
            const passenger = { ...this.passenger, passengerType, arl }
            this.passengers.push(passenger)
            this.$emit('input', this.passengers.slice(0))
            Object.keys(this.passenger).map((key) => (this.passenger[key] = ''))
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
        removePassenger(index) {
            this.passengers.splice(index, 1)
            this.$emit('input', this.passengers.slice(0))
        },
        // loadPassengerTypes(){
        //     const vr = Object.assign({}, vigilanceRepository);
        //     vr.getVisitorTypesByGroup('vehicular')
        //     .then(data => this.passengerTypes = data)
        //     .catch(error => toastr.error('Ocurrió un error al cargar los tipos de pasajero'));
        // }
    },
    created() {
        // this.loadPassengerTypes();
    },
}
</script>
